define('admin/teams/edituser',['jquery', 'plugins/http', 'knockout', 'durandal/app'], function($, http, ko, app) {
    var viewmodel = function() {
        var self = this;
        
        self.teams = ko.observableArray([]);
        self.userEmail = ko.observable();
        self.userPassword = ko.observable();
        self.userIsAdmin = ko.observable(false);
        self.errormessage = ko.observable();
        self.userDisplayName = ko.observable();

        self.activate = function (user, goBackFunc) {
            self.user = user;
            self.exit = goBackFunc;
            self.refreshUser();
            
        };

        self.refreshUser = function () {

            self.getUserDetails(self.user.id)
                .then(self.processUser)
                .fail(app.showError);
        };

        self.processUser = function (response) {
            // check for error
            if (response.error) {
                self.errormessage = response.error;
                return;
            }

            var user = response.data.user;
            self.userEmail(user.email);
            self.userPassword(user.password);
            self.userIsAdmin(user.isAdmin);
            self.userDisplayName(user.displayName);
            self.userData = user;
        };

        self.clearForm = function () {
            self.userEmail('');
            self.userIsAdmin(false);
        };

        self.updateUser = function () {
            var user = {
                email: self.userEmail(),
                isCompanyAdmin: self.userIsAdmin(),
                password: self.userPassword(),
                id: self.user.id
            };

            if (!user.email) {
                app.showMessage('Email cannot be empty');
                return;
            }

            // check if anything has actually changed
            if (self.userData.email === self.userEmail() && self.userData.password === self.userPassword() && self.userData.isAdmin === self.userIsAdmin()) {
                // nothing changed so just exit
                self.clearForm();
                self.exit();
            }
            else {
                self.updateUserDetails(user).then(function () {
                    self.clearForm();
                    self.exit();
                })
                .fail(app.showError);
            }
        };

        self.getUserDetails = function (id) {
            var url = '/api/admin/teams/user';

            return http.post(url, { UserId: id });
        };

        self.updateUserDetails = function (user) {
            var url = '/api/admin/teams/updateuser',
                data = user;

            return http.post(url, data);
        };


        self.cancelEdit = function () {
            self.clearForm();
            self.exit();
        };
    };

    return viewmodel;
});

